module.exports = {"230229100":"克山镇","230229101":"北兴镇","230229102":"西城镇","230229103":"古城镇","230229104":"北联镇","230229105":"西河镇","230229106":"双河镇","230229200":"河南乡","230229203":"河北乡","230229204":"古北乡","230229205":"西联乡","230229206":"发展乡","230229207":"西建乡","230229208":"向华乡","230229210":"曙光乡","230229400":"克山县河北林场","230229401":"克山县涌泉林场","230229402":"克山县北联林场","230229580":"克山县第一良种场","230229581":"克山县第二良种场","230229583":"克山县种猪场","230229584":"克山县种畜场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230229.json
// module id = 791
// module chunks = 0